import { useSuspenseQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { i18nService } from '@avanta/shared/services/i18n';
import { UsersService } from '@avanta/shared/services/users';
import { useAuthStore } from '@avanta/shared/stores/auth';
import { type User } from '@avanta/shared/types/users';
import { getUserId } from '@avanta/shared/utils/storage';

export interface UseSuspenseFetchUserOptions {
  setUser: (user: User) => void;
}

export const useSuspenseFetchUser = ({ setUser }: UseSuspenseFetchUserOptions): User => {
  const authUserId = useAuthStore(state => state.authInfo?.user?.id);
  const userId = authUserId || getUserId();

  const { data } = useSuspenseQuery({
    queryKey: [QUERY_KEYS.FETCH_USER, userId],
    queryFn: () => {
      if (!userId) {
        throw new Error('Missing user id');
      }

      return UsersService.getUser(userId);
    },
    select: response => response.data,
  });

  useEffect(() => {
    setUser(data);
    i18nService.changeLanguage(data.appLanguage);
  }, [data, setUser]);

  return data;
};
